import { ResponsiveContainer } from 'recharts';
import React from 'react';

/**
 * Props interface for LivisResponsiveWrapper component
 */
interface Props {
  /** The chart component to be wrapped with responsive behavior */
  children: React.ReactElement;
  /** Width of the container - can be percentage string or pixel number */
  width?: string | number;
  /** Height of the container - can be percentage string or pixel number */
  height?: string | number;
  style?: React.CSSProperties;
}

/**
 * LivisResponsiveWrapper - A wrapper component that makes charts responsive
 *
 * This component wraps any chart component with Recharts ResponsiveContainer
 * to provide automatic resizing based on parent container dimensions.
 * It ensures charts scale properly across different screen sizes and container widths.
 *
 * @param {Props} props - The wrapper configuration props
 * @returns {JSX.Element} The chart wrapped in a responsive container
 */
const LivisResponsiveWrapper = ({
  children,
  width = '100%', // Default to full width of parent container
  height = 300, // Default height in pixels
  style
}: Props) => {
  return (
    <ResponsiveContainer width={width} height={height} style={style}>
      {children}
    </ResponsiveContainer>
  );
};

export default LivisResponsiveWrapper;
